import React  from 'react';

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,


} from "react-router-dom";
import './App.css';
import LoginPage from "./components/user/LoginPage.js";
import ProfilePage from"./components/user/ProfilePage.js";
import RegisterForm from "./components/user/RegisterForm";
import HomePage from "./pages/HomePage";
import TodosPage from "./pages/TodosPage";
import AdminPage from "./pages/AdminPage";
import ProjectsPage from "./pages/ProjectsPage";
import ProjectPage from "./pages/ProjectPage";
import NavBar from "./components/NavBar";


// import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { ThemeProvider } from './components/theme/ThemeContext';


function App() {

  return (
    <ThemeProvider >
    <div
      className="App"
      id="app"
    >
         
      <header

      >
        <NavBar />

      </header>
      
      <Router
       future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
      >
        <Routes
        >
          <Route path='/' element={<HomePage />} />
          <Route path='*' element={<Navigate to='/' />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/profile" element={<ProfilePage />} exact />
          <Route path="/register" element={<RegisterForm />} />
          <Route path="/admin" element={<AdminPage />} />
            <Route path="/todos" element={<TodosPage />} />
            <Route path="/projects" element={<ProjectsPage />} />
            <Route path="/project" element={<ProjectPage />} />
        </Routes>

      </Router>
      
    </div>
    </ThemeProvider>
  );
}

export default App;
